"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditablePagesForm = void 0;
const Form_1 = require("@juvare/common-form-ui/Form");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const EditablePagesForm = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(Form_1.Form, { config: {
            type: 'form',
            children: [
                {
                    key: 'active',
                    type: 'form.checkbox',
                    label: t('editablePages.editablePagesForm.labels.active'),
                    description: t('editablePages.editablePagesForm.descriptions.active'),
                    defaultValue: false,
                },
                {
                    type: 'form.panel',
                    children: [
                        {
                            key: 'label',
                            type: 'form.text',
                            label: t('editablePages.editablePagesForm.labels.label'),
                            description: t('editablePages.editablePagesForm.descriptions.shownInMenuExample'),
                            validate: { required: true },
                        },
                        {
                            key: 'url',
                            type: 'form.text',
                            label: t('editablePages.editablePagesForm.labels.url'),
                            description: t('editablePages.editablePagesForm.descriptions.url'),
                            validate: {
                                required: true,
                                custom: (value) => /^[a-z0-9-]+$/.test(value !== null && value !== void 0 ? value : '') ? undefined : 'Lowercase letters, numbers and dash allowed only',
                            },
                        },
                        {
                            key: 'order',
                            type: 'form.number',
                            label: t('editablePages.editablePagesForm.labels.order'),
                            description: t('editablePages.editablePagesForm.descriptions.order'),
                            validate: { required: true },
                        },
                    ],
                    style: {
                        layout: 'row',
                    },
                },
                {
                    key: 'title',
                    type: 'form.text',
                    label: t('editablePages.editablePagesForm.labels.title'),
                    description: t('editablePages.editablePagesForm.descriptions.title'),
                    emptyAsNull: true,
                },
                ...(props.tags && props.tags.length > 0
                    ? [
                        {
                            key: 'tags',
                            type: 'form.multiSelect',
                            label: t('editablePages.editablePagesForm.labels.tags'),
                            description: t('editablePages.editablePagesForm.descriptions.tags'),
                            values: props.tags,
                        },
                    ]
                    : []),
                {
                    key: 'contentInfo',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                    html: `<a style="text-decoration: underline; color: #0e6dce" href='https://www.markdownguide.org/basic-syntax/' target='_blank' rel='noreferrer'>Markdown language</a>&nbsp;must be used for page content`,
                },
                {
                    key: 'content',
                    type: 'form.text',
                    label: t('editablePages.editablePagesForm.labels.content'),
                    multiline: true,
                    rows: 40,
                    style: {
                        monospace: true,
                    },
                },
            ],
        }, data: props.data, trackChanges: 'ask-to-save', onChanged: props.onChanged, onSubmit: props.onSubmit }));
};
exports.EditablePagesForm = EditablePagesForm;
